import * as React from "react";

import { decimalCalc } from "../../../../../../../../../../server/lib/ad-copy/aggregate/common";
import { Constant, SegmentPurchaseIntent } from "../../../../../../../../../../server/analytics/v3/output";
import { User } from "../../../../../../../../../../server/analytics/reference-source-data";

type Props = {
	constValue: Constant;
	isExistingBrand: boolean;
	user: User;
	segmentPurchaseIntent: SegmentPurchaseIntent;
};

// 基人口(万人)
// 購入意向ワンナンバースコア
// 定数
// のテーブル

const thStyle = {
	width: "128px",
} as const satisfies React.CSSProperties;

export const AdCopyUserTable = React.memo((props: Props) => {
	const { constValue, isExistingBrand, segmentPurchaseIntent, user } = props;

	// TODO: カテゴリユーザー数はどこから取れる？
	// const userSizeData = isExistingBrand
	// 	? simulationReferenceData.brandUserSizeData
	// 	: simulationReferenceData.categoryUserSizeData;

	const userSizeData = isExistingBrand ? user.gSize_BrandUser : user.gSize_BrandUser;

	return (
		<table className="result-table">
			<thead>
				<tr>
					<th colSpan={2} />

					<th style={thStyle}>基人口(万人)</th>

					<th style={thStyle}>購入意向ワンナンバースコア</th>

					<th style={thStyle}>定数</th>
				</tr>
			</thead>

			<tbody>
				<tr>
					<td
						className="label-area"
						rowSpan={2}
						style={{
							verticalAlign: "top",
						}}
					>
						カテゴリユーザー
					</td>

					<td className="label-area">ブランドユーザー</td>

					{/* 基人口(万人) */}
					<td>{decimalCalc(userSizeData * 100).toFixed(1)}</td>

					{/* 購入意向ワンナンバースコア */}
					{/* NOTE: 新規ブランドの場合は、ゼロが返ってくるはず */}
					<td>{decimalCalc(segmentPurchaseIntent.brandUser.score).toFixed(1)}</td>

					{/* 定数 */}
					<td>{constValue.c1.toFixed(2)}</td>
				</tr>

				<tr>
					<td className="label-area">ノンユーザー</td>

					{/* 基人口(万人) */}
					<td>{decimalCalc(user.gSize_BrandNonuser * 100).toFixed(1)}</td>

					{/* 購入意向ワンナンバースコア */}
					<td>{decimalCalc(segmentPurchaseIntent.brandNoneUser.score).toFixed(1)}</td>

					{/* 定数 */}
					<td>{constValue.c2.toFixed(2)}</td>
				</tr>

				<tr>
					<td className="label-area" colSpan={2}>
						カテゴリノンユーザー
					</td>

					{/* 基人口(万人) */}
					<td>{decimalCalc(user.gSize_CategoryNonuser * 100).toFixed(1)}</td>

					{/* 購入意向ワンナンバースコア */}
					<td>{decimalCalc(segmentPurchaseIntent.categoryNoneUser.score).toFixed(1)}</td>

					{/* 定数 */}
					<td>{constValue.c3.toFixed(2)}</td>
				</tr>
			</tbody>
		</table>
	);
});
